import { FC, PropsWithChildren, useState } from "react";
import clsx from "clsx";
import { List, Star } from "lucide-react";
import { PromptLibraryTab } from "@/modules/promptLibrary/promptLibrary.types";

interface Props {
  onTabClick: (value: PromptLibraryTab) => void;
}

export const PromptLibraryRightDrawerTabs: FC<PropsWithChildren<Props>> = ({ children, onTabClick }) => {
  const [activeTab, setActiveTab] = useState<"all" | "favourite">("all");

  const handleTabClick = (tab: "all" | "favourite") => {
    setActiveTab(tab);
    onTabClick(tab === "favourite" ? "favourite" : "all");
  };

  return (
    <div>
      <div className="flex gap-2 px-4 py-3">
        <button
          onClick={() => handleTabClick("all")}
          className={clsx("flex items-center gap-1.5 rounded px-2 py-1 text-sm transition-all", {
            "bg-ivory-mist-200 text-foreground": activeTab === "all",
            "text-muted-foreground hover:bg-ivory-mist-100": activeTab !== "all",
          })}
        >
          <List size={14} />
          All
        </button>
        <button
          onClick={() => handleTabClick("favourite")}
          className={clsx("flex items-center gap-1.5 rounded px-2 py-1 text-sm transition-all", {
            "bg-ivory-mist-200 text-foreground": activeTab === "favourite",
            "text-muted-foreground hover:bg-ivory-mist-100": activeTab !== "favourite",
          })}
        >
          <Star size={14} />
          Favourite
        </button>
      </div>
      {children}
    </div>
  );
};
